import React, { useContext, useEffect, useState, useRef } from "react";
import PageName from "../Utils/PageName";
import { Link } from "react-router-dom";
import { environmentVariables } from "../../config/env.config";
import axios from "axios";
import { userContext } from "../../context/userContext";
import { ToastContainer, toast } from "react-toastify";
import ReactDOM from "react-dom";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { businessContext } from "../../context/businessContext";
import CircularLoader from "../../Backend/Components/CircularLoader/CircularLoader";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { width } from "@material-ui/system";
import { fetchCountries, getCurrencyDataByCurrency, subtractDays } from "../../utils/utility";
import TooltipImg from "./../../Images/info.png";
import { FaCalendarAlt } from 'react-icons/fa';

function ClaimRequest() {
  const fromDate = useRef(null);
  const toDate = useRef(null);
  
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // const [isLoading, setIsLoading] = useState(false);

  const [loading, setLoading] = useState(true);
  const baseUrl = environmentVariables?.apiUrl;
  const { userData, setUserData } = useContext(userContext);
  const [isCoupon, setIsCoupon] = useState(false);
  const [payinOut, setPayinOut] =useState("");
  const [paidAmount, setPaidAmount] =useState("");
    const { t } = useTranslation();
  const [minDate, setMinDate] =useState("");
  const [amountStatus, setAmountStatus] =useState("");
  // const [paymentdate, setPaymentdate] = useState("");
  const [description, setDescription] = useState("");
  const [editStatus, setEditStatus] = useState("");

  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const [nameOrderId, setNameOrderId] = useState("");
  const [totalPayin, setTotalPayin] = useState(0);
  const [totalPayout, setTotalPayout] = useState(0);
  const [totalClaimable, setTotalClaimable] = useState(0);
  const [totalSettlementFee, setTotalSettlementFee] = useState(0);
  const [totalSettlementtxn, setTotalSettlementtxn] = useState(0);
  const [totalPayintxn, setTotalPayintxn] = useState(0);
  const [totalPayoutFee, setTotalPayoutFee] = useState(0);
  const [totalPayouttxn, setTotalPayouttxn] = useState(0);

  const [totalPayinwithoutFilter, setTotalPayinwithoutFilter] = useState(0);
  const [totalPayoutwithoutFilter, setTotalPayoutwithoutFilter] = useState(0);
  const [unsettledwithoutFilter, setUnsettledwithoutFilter] = useState(0);

  const [selectedDashDateFrom, setSelectedDashDateFrom] = useState("");
  const [selectedDashDateTo, setSelectedDashDateTo] = useState("");
  const dashFromDate = useRef(null);
  const dashToDate = useRef(null);


  // const [couponName, setCouponName] = useState("");
  const [isStatus, setIsStatus] = useState(false);
  // const [couponCode, setCouponCode] = useState("");
  // const [discountType, setDiscountType] = useState("");
  // const [discountValue, setDiscountValue] = useState("");
  const [activate, setActivate] = useState(false);
  // const [paymentId, setPaymentId] = useState("");
  const createCouponModalRef = useRef(null);
  const tableExtensions = { export: false, print: false };

  const [isUpdate, setIsUpdate] = useState(false);
  const [couponId, setCouponId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("IN");
  const [currencySymbol, setCurrencySymbol] = useState("");

  const fetchDataCountries = async () => {
    const countryData = await fetchCountries();
    setCountries(countryData);
  };

  useEffect(() => {
    fetchDataCountries();
  }, []);

  const handleCountryChange = (e) => {
    const selectedCode = e.target.value;
    setSelectedCountryCode(selectedCode);
  };


  useEffect(() => {
    if (selectedCountryCode || selectedDashDateFrom || selectedDashDateTo) {
      getDashboardData();
    }
  }, [selectedCountryCode, selectedDashDateFrom, selectedDashDateTo]);


  const getDashboardData = () => {
    axios
      .get(`${baseUrl}api/v1/custompayment/getwalletsummry`, {
        params: { country: selectedCountryCode, from_date: selectedDashDateFrom, to_date: selectedDashDateTo },
        headers: {
          _token: userData?.token,
        },
      })
      .then((res) => {
        if (res?.status === 200) {
          setTotalPayin(res?.data?.result?.consolidatedData?.payin_amount || 0);
          setTotalPayintxn(res?.data?.result?.consolidatedData?.payin_count || 0);
          let showPayout = Number(res?.data?.result?.consolidatedPayoutData?.payout_amount) - Number(res?.data?.result?.consolidatedPayoutData?.payout_fee);
          setTotalPayout(showPayout || 0);
          setTotalPayoutFee(res?.data?.result?.consolidatedPayoutData?.payout_fee || 0);
          setTotalPayouttxn(res?.data?.result?.consolidatedPayoutData?.payout_count || 0);
          let claimableData = res?.data?.result?.consolidatedData?.settled_amount - res?.data?.result?.consolidatedData?.settled_fee;
          setTotalClaimable(claimableData);
          setTotalSettlementFee(res?.data?.result?.consolidatedData?.settled_fee);
          setTotalSettlementtxn(res?.data?.result?.consolidatedData?.settled_count);
          setCurrencySymbol(res?.data?.result?.currency);
          setTotalPayinwithoutFilter(res?.data?.result?.payinWalletData || 0);
          setTotalPayoutwithoutFilter(res?.data?.result?.payoutWalletData || 0);
          setUnsettledwithoutFilter(res?.data?.result?.unsettledAmountData || 0);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.error("Resource not found:", error);
        } else {
          console.error("error:", error);
        }
      });
  };


  const fetchCoupon = async (page, size = perPage) => {
    try {
      axios
        .get(`${baseUrl}api/v1/custompayment/getAllCustomClaimRequest?name_order_id=${nameOrderId}&from_date=${selectedDateFrom}&to_date=${selectedDateTo}&page=${page}&limit=${size}&type=claimrequest`)
        .then((response) => {
          console.log("response===>>>", response);
          setData(response?.data?.result);
          setTotalRows(response.data.totalRecords);
          setCurrentPage(response.data.currentPage);
          setIsLoading(false)

        })
        .catch((error) => {
          console.log("response===>>>", error);
          console.log(error);
          setIsLoading(false)
        });
    } catch (err) { }
  };
  useEffect(() => {
    fetchCoupon(1);
    return () => {
      // Remove the event listener when the component unmounts
      $(createCouponModalRef.current).off("hidden.bs.modal");
    };
  }, [selectedDateFrom, selectedDateTo, nameOrderId]);

  const handleReset = () => {
    setSelectedDateFrom("");
    setSelectedDateTo("");
    setNameOrderId("")
  };
  const handleResetDash = () => {
    setSelectedDashDateFrom("");
    setSelectedDashDateTo("");
    setSelectedCountryCode("IN");
  };

  const handlePageChange = (page) => {
    fetchCoupon(page);
  };

  // When user changes rows per page
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchCoupon(page, newPerPage);
  };



     function useWindowWidth() {
        const [width, setWidth] = useState(window.innerWidth);
        useEffect(() => {
          const handleResize = () => setWidth(window.innerWidth);
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);
        return width;
      }
  
  
    const windowWidth = useWindowWidth();
  
  
    const getStatusStyle = (status) => {
  const styles = {
    failed:       { color: "#e71c1f",    background: "#e71c1f33" },
    pending:      { color: "#ffa401",    background: "#ffa40133" },
    completed:    { color: "#2892D5",    background: "#2892D533" },
    settled:      { color: "#26a56a",    background: "#26a56a33" },
    transaction_not_paid_yet: { color: "#ff6600", background: "#ff660033" },
  };

  const { color = "#000", background = "#00000033" } = styles[status] || {};

  return {
    fontWeight: "500",
    color,
    background,
    borderRadius: "4px",
    padding: "2px 0px",
    textTransform: "capitalize",
    minWidth: "90px",
    maxWidth: "90px",
    display: "block",
    textAlign: "center",
  };
};

    const columns = [
      {
        name: "Owner Name",
        selector: (row) => row?.boUser?.name || "--",
        cell: (row) => (
          <div className="custom-cell" data-column-name="Owner Name">
            {row?.boUser?.name || "--"}
          </div>
        ),
        sortable: true,
        minWidth: windowWidth > 768 ? "180px" : "100%",
      },
      {
        name: "Owner Email",
        selector: (row) => row?.boUser?.email?.toLowerCase() || "--",
        cell: (row) => (
          <div className="custom-cell" data-column-name="Owner Email">
            {row?.boUser?.email?.toLowerCase() || "--"}
          </div>
        ),
        sortable: true,
        minWidth: windowWidth > 768 ? "200px" : "100%",
      },
      {
        name: "Created Date",
        selector: (row) => {
          const date = new Date(row.created_at);
          return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
        },
        cell: (row) => {
          const date = new Date(row.created_at);
          return (
            <div className="custom-cell" data-column-name="Created Date">
              {date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </div>
          );
        },
        sortable: true,
        minWidth: windowWidth > 768 ? "180px" : "100%",
      },
      {
        name: "Requested Amount",
        selector: (row) => row?.requested_amount == null ? "--" : row?.requested_currency === "د." || row?.requested_currency === "AED" ? `${row?.requested_amount} AED` : `${getCurrencyDataByCurrency(row.requested_currency)}${row?.requested_amount}`,
        cell: (row) => (
          <div className="custom-cell" data-column-name="Requested Amount">
            {row?.requested_amount == null ? "--" : row?.requested_currency === "د." || row?.requested_currency === "AED" ? `${row?.requested_amount} AED` : `${getCurrencyDataByCurrency(row.requested_currency)}${row?.requested_amount}`}
          </div>
        ),
        sortable: true,
        minWidth: windowWidth > 768 ? "200px" : "100%",
      },
      {
        name: "Amount to Pay",
        selector: (row) =>
          row.payment_status === "failed" || row.payment_status === "pending"
            ? row?.requested_currency === "د." || row?.requested_currency === "AED" ?  row.paid_amount + " "+ row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount : "0",
        cell: (row) => (
          <div className="custom-cell" data-column-name="Amount to Pay">
            {row.payment_status === "failed" || row.payment_status === "pending"
              ? row?.requested_currency === "د." || row?.requested_currency === "AED" ?  row.paid_amount + " "+ row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount : "0"}
          </div>
        ),
        sortable: true,
        minWidth: windowWidth > 768 ? "180px" : "100%",
      },
      {
        name: "Paid Amount",
        selector: (row) =>
          row.payment_status === "failed" || row.payment_status === "pending"
            ? "--"
            : row?.requested_currency === "د." || row?.requested_currency === "AED" ?  row.paid_amount + " "+ row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount,
        cell: (row) => (
          <div className="custom-cell" data-column-name="Paid Amount">
            {row.payment_status === "failed" || row.payment_status === "pending"
              ? "--"
              : row?.requested_currency === "د." || row?.requested_currency === "AED" ?  row.paid_amount + " "+ row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount}
          </div>
        ),
        sortable: true,
        minWidth: windowWidth > 768 ? "180px" : "100%",
      },
      {
        name: "Payment Date",
        selector: (row) => {
          const date = new Date(row.payment_date);
          return row.payment_status == 'completed' ?
          isNaN(date) || date.getFullYear() === 1970
            ? "--"
            : date.toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              }):'--';
        },
        cell: (row) => {
          const date = new Date(row.payment_date);
          return (
            row.payment_status == 'completed' ?
            <div className="custom-cell" data-column-name="Payment Date">
              {isNaN(date) || date.getFullYear() === 1970
                ? "--"
                : date.toLocaleString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
            </div>
            :'--'
          );
        },
        sortable: true,
        minWidth: windowWidth > 768 ? "200px" : "100%",
      },
      {
        name: "Payment Status",
        selector: (row) =>
          row.payment_status === "failed" ? "Cancel" : row.payment_status,
        cell: (row) => (
          <div className="custom-cell" data-column-name="Payment Status">
            <span style={getStatusStyle(row.payment_status )}>{row.payment_status === "failed" ? "Cancel" : row.payment_status}</span>
          </div>
        ),
        sortable: true,
        minWidth: windowWidth > 768 ? "180px" : "100%",
      },
      {
        name: "Action",
        cell: (row) => {
          const isCompleted = row?.payment_status === "completed" || row?.payment_status === "failed";
          return (
            <div className="custom-cell" data-column-name="Action">
              <i
                className="first fas fa-pen"
                onClick={() => {
                  if (!isCompleted) {
                    handleEdit(row);
                  }
                }}
                style={{
                  cursor: isCompleted ? "no-drop" : "pointer",
                  opacity: isCompleted ? 0.5 : 1,
                  marginRight: "10px",
                }}
              ></i>
            </div>
          );
        },
        sortable: false,
        minWidth: windowWidth > 768 ? "120px" : "100%",
      },
    ];
    
  const customStyles = {

    headRow: {
      style: {
        display: "flex",
        alignItems: "stretch",
        width: "100%",
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",

      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px",
        minHeight: "52px",
        fontSize: "15px",
        width: "190px",
        whiteSpace: "normal",
        wordBreak: "break-word",

      },
    },
    rows: {
      style: {
        padding: "20px 25px",
        fontSize: "14px",
        textTransform: "capitalize",
        minHeight: "48px ",
      },
    },
  };

  const tableData = {
    columns,
    data,
  };

  let objw = {
    payinpayout_id: payinOut,
    paid_amount: paidAmount,
    payment_status: amountStatus,
    // payment_date: paymentdate,
    // payment_id: paymentId,
    payment_remarks: description
  };

  // console.log(objw, "objecttqweqwe");


  const handleSubmit = async (e) => {
    try {
      setIsStatus(true);
      let obj = {
        payinpayout_id: payinOut,
        payment_status: amountStatus,
        payment_remarks: description
      };
      axios.post(`${baseUrl}api/v1/custompayment/updateCustompayClaimRequest`, obj)
        .then((res) => {
          setIsStatus(false);
          if (res && res?.data && res?.data?.success) {
            fetchCoupon(1);
            handleClearState();
            getDashboardData();
            toast.success(res?.data?.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            });
            $(createCouponModalRef.current).modal("hide");
          }
        }).catch((err) => {
          console.log(err);
          setIsStatus(false);
          toast.error(err?.response?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        })

    } catch (err) {
      setIsStatus(false);
      toast.error(err?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  };

  const handleClearState = () => {
    try {
      // e.preventDefault();
      setPayinOut("");
      setMinDate("");
      setPaidAmount("");
      setAmountStatus("");
      // setPaymentdate("");
      setEditStatus("")
      setDescription("");
      setActivate(false);
      // setPaymentId("");
      setIsUpdate(false);
      setCouponId("");
      setIsCoupon(false);
    } catch (err) {
      console.log(err, "erororo");
    }
  };

  const handleEdit = (el) => {
    try {
      setIsUpdate(true);
      // setCouponId(el?.id);
      console.log(el, "ellll2l");
      setPayinOut(el?.id);
      setMinDate(new Date(el?.created_at).toISOString().split("T")[0])
      // setPaidAmount(el?.requested_amount);
      if (el?.payment_status === "pending") {
        setPaidAmount(el?.paid_amount); // Set requested amount to paidAmount
      } else {
        setPaidAmount(el?.paid_amount || ""); // Otherwise, set it to paid amount
      }
      setAmountStatus(el?.payment_status);
      setEditStatus(el?.payment_status)
      const formattedDate = el?.payment_date
      ? new Date(el.payment_date).toISOString().split("T")[0]
      : "";
      // setPaymentdate(formattedDate);
      setDescription(el?.payment_remarks);
      // setActivate(el?.is_active == 0 ? false : true);
      // setPaymentId(el?.payment_id);
      setIsCoupon(true);
      setIsStatus(false);
      $(createCouponModalRef.current).modal("show");
    } catch (err) {
      console.log(err, "Errorro");
    }
  };
  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    noRowsPerPage: false,  
    selectAllRowsItem: false,
    // selectAllRowsItemText: t("All"),
  };

  return (
    <>
      <PageName PageName="Claim Request" />
      <article id="custom_table">
        <div className="main claimRequest">
          <div style={{ marginBottom: "40px" }} className="walletDashboardtop">
            <div className="upperFilter">
              <div className=" SuperDashboardTop">
                <h3>Welcome Back, {userData?.user_type == "subAdmin" ? "Sub Admin" : "Super Admin"}!</h3>
                <h4>Here’s what happening with your business </h4>
              </div>
               <div className="" style={{ display: "flex", justifyContent: "flex-end", marginLeft:windowWidth > 768? "10px" :'0' }}>
                  <select
                    className="form-select "
                    style={{ width: "200px" }}
                    name="country"
                    value={selectedCountryCode}
                    onChange={handleCountryChange}
                  >
                    <option value="">Select Country</option>
                    {/* {!!countries && countries?.length > 0 && countries?.map((country) => ( */}
                    {!!countries && countries?.length > 0 && countries?.filter(country =>
                      country?.short_code === "IN" || country?.short_code === "AE"
                    ).map((country) => (
                      !!country?.id &&
                      <option key={country?.name} value={country?.short_code}>
                        {country?.name?.charAt(0)?.toUpperCase() + country?.name?.slice(1)}
                      </option>
                    ))}
                  </select>
                </div>             
            </div>


             <div className="row">
              <div class="col-md-4">
                <div className="tile bbox" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                  <div className=" below-1400-none">
                    <i
                      class="fa-solid fa-hand-holding-dollar"
                      style={{ background: "rgb(251, 241, 255)", color: "rgb(158, 62, 191)", display: "flex" }}
                    ></i>
                  </div>
                  <div>
                    <div className="tooltip-wrapper" >

                      <h3 className="tooltipcontainer_infdash">
                        Total Pay-In
                        <div className="tooltipDiv">
                          
                          <span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                          <span className="tooltip ">{t("Total_earning_tooltip")} </span></div>
                      </h3>
                    </div>
                    {/* {console.log(currencySymbol, "currencySymbol")} */}
                     {currencySymbol !== "AED" ? (
                      <h4> {getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayinwithoutFilter)?.toFixed(2) || 0}</h4>     
                      ) : (
                      <h4> {Number(totalPayinwithoutFilter)?.toFixed(2) || 0} {currencySymbol}</h4>
                      )}
                    {/* <h4>{currencySymbol}{Number(totalPayin)?.toFixed(2) || 0}</h4> */}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div className="tile bbox" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                  <div className=" below-1400-none">
                    <i
                      class="fa-solid fa-file-invoice-dollar"
                      style={{ background: "rgb(243, 241, 255)", color: "rgb(81, 69, 158)", display: "flex" }}
                    ></i>
                  </div>

                  <div>
                    <div className="tooltip-wrapper">
                      <h3 className="tooltipcontainer_infdash">
                        {/* {t("Total_claimable_amount")}  */}
                       Total Payout 
                        <div className="tooltipDiv"><span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                          <span className="tooltip"
                          >
                            {/* {t("Total_claim_amount_tooltip1")} <br/> */}
                            {t("Total_claim_amount_tooltip_admin")}</span></div>
                      </h3>
                      {currencySymbol !== "AED" ? (
                      <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayoutwithoutFilter)?.toFixed(2) || 0}</h4>
                    ) : (
                      <h4>{Number(totalPayoutwithoutFilter)?.toFixed(2) || 0} {currencySymbol}</h4>
                    )}

                      {/* <h4>
                    {currencySymbol}{Number(totalClaimable)?.toFixed(2) || 0}
                  </h4> */}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div className="tile bbox" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                  <div className=" below-1400-none">
                    <i
                      class="fa-solid fa-money-bill-transfer"
                      style={{ background: "rgb(255, 239, 235)", color: "rgb(248, 124, 91)", display: "flex" }}
                    ></i>
                  </div>
                  <div>
                    <div className="tooltip-wrapper">
                      <h3 className="tooltipcontainer_infdash">
                       Total Unsettled 
                        <div className="tooltipDiv"><span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                          <span className="tooltip"
                          >{t("Total_withdrawn_amount_tooltip_admin")} </span></div>
                      </h3>
                    </div>
                    {/* <h4>{currencySymbol}{Number(totalPayout)?.toFixed(2) || 0}</h4> */}

                    {currencySymbol !== "AED" ? (
                      <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(unsettledwithoutFilter)?.toFixed(2) || 0}</h4>
                    ) : (
                      <h4>{Number(unsettledwithoutFilter)?.toFixed(2) || 0} {currencySymbol}</h4>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div>
               <div className="filterWrapper" style={{justifyContent:"flex-end", marginBottom: "20px", width:"100%"}}>
                <div style={{ display: "flex", alignItems:"center" }}>
                  <div >
                    <DatePicker
                      placeholderText="From Date"
                      selected={selectedDashDateFrom ? new Date(selectedDashDateFrom) : null}
                      onChange={(date) => {
                        if (date) {
                          const timestamp = date.getTime();
                          setSelectedDashDateFrom(timestamp);
                        }
                      }}
                      className="form-control"
                      ref={dashFromDate}
                      dateFormat="dd/MM/yyyy"
                      popperPlacement="bottom-end"
                      minDate={subtractDays(30)}
                      maxDate={new Date()}
                    />
                  </div>
                   <FaCalendarAlt className="calenderIcon" />
                  <div style={{ marginLeft: "10px" }}>
                    <DatePicker
                      placeholderText="To Date"
                      selected={selectedDashDateTo ? new Date(selectedDashDateTo) : null}
                      onChange={(date) => {
                        if (date) {
                          const timestamp = date.getTime();
                          setSelectedDashDateTo(timestamp);
                        }
                      }}
                      className="form-control"
                      ref={dashToDate}
                      dateFormat="dd/MM/yyyy"
                      popperPlacement="bottom-end"
                      minDate={selectedDashDateFrom ? selectedDashDateFrom : subtractDays(30)}
                      maxDate={new Date()}
                    />
                  </div>
                    <FaCalendarAlt className="calenderIcon" />
                </div>

               
                <div
                  onClick={() => handleResetDash()}
                  className=""
                  style={{ marginLeft: "10px", cursor: "pointer", fontWeight: "600", fontSize: "14px" }}
                >
                  <i className="fa fa-filter" aria-hidden="true"></i>&nbsp;
                  {t("Clear_filters")}
                </div>
              </div>  
            </div>
            <div className="row lowerCard">
              <div class="col-md-4">
                <div className="tile bbox" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                  <div className=" below-1400-none">
                    <i
                      class="fa-solid fa-hand-holding-dollar"
                      style={{ background: "rgb(251, 241, 255)", color: "rgb(158, 62, 191)", display: "flex" }}
                    ></i>
                  </div>
                  <div>
                    <div className="tooltip-wrapper" >

                      <h3 className="tooltipcontainer_infdash">
                        Unsettled
                        <div className="tooltipDiv">
                          <span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                          <span className="tooltip ">{t("Total_earning_tooltip")} </span></div>
                      </h3>
                    </div>
                    {currencySymbol !== "AED" ? (
                      <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayin)?.toFixed(2) || 0}</h4>
                    ) : (
                      <h4>{Number(totalPayin)?.toFixed(2) || 0} {currencySymbol}</h4>
                    )}
                   <div className="fees"> <p>Total Txn: {totalPayintxn}</p></div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div className="tile bbox" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                  <div className=" below-1400-none">
                    <i
                      class="fa-solid fa-file-invoice-dollar"
                      style={{ background: "rgb(243, 241, 255)", color: "rgb(81, 69, 158)", display: "flex" }}
                    ></i>
                  </div>

                  <div>
                    <div className="tooltip-wrapper">
                      <h3 className="tooltipcontainer_infdash">
                        {/* {t("Total_claimable_amount")}  */}
                        Settled
                        <div className="tooltipDiv"><span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                          <span className="tooltip"
                          >
                            {/* {t("Total_claim_amount_tooltip1")} <br/> */}
                            {t("Total_claim_amount_tooltip_admin")}</span></div>
                      </h3>
                      {currencySymbol !== "AED" ? (
                        <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalClaimable)?.toFixed(2) || 0}</h4>
                      ) : (
                        <h4>{Number(totalClaimable)?.toFixed(2) || 0} {currencySymbol}</h4>
                      )}

                      <div className="fees"> <p>Fees:
                        {currencySymbol !== "AED" ? (
                        <>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalSettlementFee)?.toFixed(2) || 0}</>
                      ) : (
                        <>{Number(totalSettlementFee)?.toFixed(2) || 0} {currencySymbol}</>
                      )}</p> |
                      <p>Total Txn: {totalSettlementtxn}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div className="tile bbox" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                  <div className=" below-1400-none">
                    <i
                      class="fa-solid fa-money-bill-transfer"
                      style={{ background: "rgb(255, 239, 235)", color: "rgb(248, 124, 91)", display: "flex" }}
                    ></i>
                  </div>
                  <div>
                    <div className="tooltip-wrapper">
                      <h3 className="tooltipcontainer_infdash">
                        Pay-Out
                        <div className="tooltipDiv"><span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                          <span className="tooltip"
                          >{t("Total_withdrawn_amount_tooltip_admin")} </span></div>
                      </h3>
                    </div>

                    {currencySymbol !== "AED" ? (
                      <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayout)?.toFixed(2) || 0}</h4>
                    ) : (
                      <h4>{Number(totalPayout)?.toFixed(2) || 0} {currencySymbol}</h4>
                    )}
                    <div className="fees"> <p>Fees: 
                      {currencySymbol !== "AED" ? (
                        <>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayoutFee)?.toFixed(2) || 0}</>
                      ) : (
                        <>{Number(totalPayoutFee)?.toFixed(2) || 0} {currencySymbol}</>
                      )}</p> |
                     <p>Total Txn: {totalPayouttxn}</p></div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div className="claimTable" >
            <h3 className="payin-payout-request-heading" style={{minWidth :"40%"}}>{t("Claim_request_list")}</h3>
          <div className="upperFilter" style={{margin:"0"}}>
            <input
              type="text"
              class="form-control clear_string customSearchField"
              placeholder="Search By Name, Email"
              value={nameOrderId}
              onChange={(e) => setNameOrderId(e.target.value.replace(/^\s+/, ""))}
              style={{width: "200px" }}
            />
           <div className="filterWrapper" style={{width:"auto"}}> 
            <div style={{ display: "flex" ,alignItems:"center"}}>
              <div>
                <DatePicker
                  placeholderText="From Date"
                  selected={selectedDateFrom ? new Date(selectedDateFrom) : null}
                  onChange={(date) => {
                    if (date) {
                      const timestamp = date.getTime();
                      setSelectedDateFrom(timestamp);
                    }
                  }}
                  className="form-control"
                  ref={fromDate}
                  dateFormat="dd/MM/yyyy"
                  popperPlacement="bottom-end"
                  minDate={subtractDays(30)}
                  maxDate={new Date()}
                />

              </div>
                <FaCalendarAlt className="calenderIcon" />
              <div style={{ marginLeft: "10px" }}>
                <DatePicker
                  placeholderText="To Date"
                  selected={selectedDateTo ? new Date(selectedDateTo) : null}
                  onChange={(date) => {
                    if (date) {
                      const timestamp = date.getTime();
                      setSelectedDateTo(timestamp);
                    }
                  }}
                  className="form-control"
                  ref={toDate}
                  dateFormat="dd/MM/yyyy"
                  popperPlacement="bottom-end"
                  minDate={selectedDateFrom ? selectedDateFrom : subtractDays(30)}
                  maxDate={new Date()}
                />
              </div>
                <FaCalendarAlt className="calenderIcon" />
            </div>
            <div
              onClick={() => handleReset()}
              className=""
              style={{ marginLeft: "10px", cursor: "pointer", fontWeight: "600", fontSize: "14px" }}
            >
              <i className="fa fa-filter" aria-hidden="true"></i>&nbsp;
              {t("Clear_filters")}
            </div>
            </div>

          </div>
          </div>
          {isLoading ? (
            <CircularLoader size={40} />
          ) : (
            <div id="specific-table" style={{ marginTop: "30px" }}>
              <DataTableExtensions
                {...tableData}
                filterPlaceholder="Search Coupon"
                customStyles={customStyles}
                {...tableExtensions}
              >
                <DataTable
                  columns={columns}
                  data={data}
                  noHeader
                  defaultSortField="id"
                  sortIcon={<SortIcon />}
                  defaultSortAsc={true}
                  pagination
                  paginationServer  
                  paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  dense
                  progressPending={isLoading}
                  paginationComponentOptions={{
                    ...paginationOptions,
                  }}
                  customStyles={customStyles}
                  noDataComponent={<div style={{ padding: "24px" }}>{t("No_records_found")}</div>}
                />
              </DataTableExtensions>
            </div>
          )}
        </div>
        <div
          className={`modal fade ${isCoupon ? "show" : ""}`}
          id="createCouponModal"
          tabIndex="-1"
          ref={createCouponModalRef}
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content" style={{ width: "50%" }}>
              <div class="modal-header">
                <h5 class="modal-title">
                  Update Transaction Status
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => handleClearState(e)}
                ></button>
              </div>
              <div class="modal-body" style={{ padding: "0" }}>
                <div className="mb-2" id="Coupons_admin_createform_container">
                  <div>
                    {/* Code */}
                    <h5 className="lable-custompayment-form">Paid Amount</h5>
                    <input
                      placeholder="Paid Amount"
                      type="text"
                      className="form-control"
                      style={{ marginBottom: "15px" }}
                      value={paidAmount}
                      onChange={(e) => setPaidAmount(e.target.value)}
                      readOnly={editStatus === "pending" || editStatus === "completed"}
                    />
                  </div>
                  <div style={{ position: "relative" }}>
                    {/* Discount Type */}
                    {/* <div style={{position:"absolute",top:"15px", right:"25px", fontSize:"20px",cursor:"pointer"}}>
                    <i class="fa-solid fa-chevron-down"></i>
                    </div> */}
                    <h5 className="lable-custompayment-form">Status</h5>
                    <select
                      className="form-control"
                      onChange={(e) => setAmountStatus(e.target.value)}
                      value={amountStatus}
                      style={{ cursor: 'pointer', appearance: "auto", borderRight: editStatus === "completed" || editStatus === "failed" ? "26px solid #e9ecef" : "26px solid transparent", marginBottom: "15px", }}
                      disabled={editStatus === "completed" || editStatus == "failed"}
                    >
                      <option value="" disabled> select Payment Status </option>
                      <option value="pending">Pending</option>
                      <option value="completed">completed</option>
                      <option value="failed">Cancel</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="modal-body" style={{ padding: "0" }}>
                <div className="mb-2">
                  <div>
                    {/* Description */}
                    <h5 className="lable-custompayment-form">Payment Remarks</h5>
                    <input
                      placeholder="Payment Remarks"
                      type="text"
                      className="form-control"
                      style={{ marginBottom: "15px" }}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      readOnly={editStatus === "completed"}
                    />
                  </div>


                </div>
              </div>

              <div class="modal-footer" id="Coupanadmin_Button_Wrapper">
                <button
                  id="Coupan_edit_Button"
                  type="button"
                  class="btn btn-primary"
                  style={{ width: "200px", background: "#333333", borderRadius: "50px", textTransform: "capitalize", fontWeight: "500" }}
                  onClick={(e) => handleSubmit(e)}
                >
                  {isStatus ? (
                    <CircularLoader size={20} />
                  ) : isUpdate ? (
                    "Update"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

export default ClaimRequest;
